var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmblemWhite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.19 173.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.1,70.14l46.24-26.7L74.1,16.74,27.85,43.44ZM47,51.81,74.1,36.18l27.07,15.63L74.1,67.44Zm68.65-8.37-12.16,7-29.41-17-29.41,17-12.16-7,41.57-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.1,0,.58,42.45,0,42.79,0,164l15.67,9,15.05-8.71.58-.35V79.16L74.1,103.81l42.73-24.64V164l15.67,9,15.65-9,0-121.22Zm70.53,43.45L74.1,84.18,3.54,43.44,74.1,2.7ZM29,162.66l-12.13,7,0-98.88,12.16,7Zm90.16-84.84,12.18-7,0,98.86-12.16-7Zm14.5,91.84V66.75L74.1,101.12,14.51,66.75l0,102.93-12.16-7,0-117.24L74.1,86.87l71.76-41.43,0,117.24Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmblemWhite);
export default __webpack_public_path__ + "static/media/emblem_white.2023015f005e65fd89a54f36e2de2d09.svg";
export { ForwardRef as ReactComponent };